import React from "react";
import {
    Row, Col, Steps, Space, DatePicker, Button, Timeline
} from 'antd';
import { Map, Polygon, Polyline, Marker, InfoWindow } from 'google-maps-react';
import place_red from '../../image/3.png';
import { getTrackview } from "./service";
import moment from 'moment';
import jQuery from 'jquery'
import {
    ShopTwoTone,
    UserOutlined,
    PhoneTwoTone,
    HomeTwoTone,
    StarTwoTone
} from '@ant-design/icons';
// import 'moment/locale/th';
// import locale from 'antd/lib/locale/th';

var place_red_resize = null;
const { Step } = Steps;
const google = window.google
const mapStyles = {
    width: '100%',
    height: '100%',
    // position: 'relative',
    // overflow: 'hidden',
    padding: '30px'
};
var directionsService = null;
var directionsDisplay = null;
const dateFormat = 'YYYY-MM-DD';


// var iconImage = new google.maps.MarkerImage('mapIcons/marker_red.png',
//     // This marker is 20 pixels wide by 34 pixels tall.
//     new google.maps.Size(20, 34),
//     // The origin for this image is 0,0.
//     new google.maps.Point(0, 0),
//     // The anchor for this image is at 9,34.
//     new google.maps.Point(9, 34));

// Shapes define the clickable region of the icon.
// The type defines an HTML &lt;area&gt; element 'poly' which
// traces out a polygon as a series of X,Y points. The final
// coordinate closes the poly by connecting to the first
// coordinate.




class View extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            markers: [],
            saleDetail: this.props.location.saleDetail,
            firstName_th: this.props.location.saleDetail.firstName_th,
            lastName_th: this.props.location.saleDetail.lastName_th,
            empCd: this.props.location.saleDetail.empCd,
            // empCd: '900001',
            // date: moment().format(dateFormat),
            date: moment(this.props.location.saleDetail.checkin_at).format(dateFormat),
            dateString: null,
            tracking: [
                {
                    "trackID": 8,
                    "empCd": 900001,
                    "storeID": null,
                    "statusID": null,
                    "latitude": "13.724122",
                    "longitude": "100.549370",
                    "loc_provinceID": null,
                    "loc_amphurID": null,
                    "loc_place": null,
                    "iDatetime": "2021-03-19 16:12:01"
                }],
            cords: [
                { lat: 9.96233, lng: 49.80404 },
                { lat: 6.11499, lng: 50.76891 },
                { lat: 6.80592, lng: 51.53548 },
                { lat: 9.50523, lng: 51.31991 },
                { lat: 9.66089, lng: 48.70158 }
            ],
            places: [
                {
                    name: "Manila",
                    title: "Manila",
                    lat: 14.6091,
                    lng: 121.0223,
                    id: 1,
                }
            ],
            attendence: [],
            value: null,
            marker: [],
            batches: [],
            directionsDisplay: null,
            showingInfoWindow: false,
            activeMarker: {},
            activeMarkerCard: false,
        }
    }

    componentDidMount() {
        // console.log("componentDidMount")
        this.getData(this.state.date);
    }

    onChange = (date, dateString) => {
        // console.log("dateString", dateString);
        this.setState({
            date: dateString,
            batches: []
        })
        // this.setState({ date: dateString }, () =>
        // console.log("this.state.date", this.state.date)
        // );
        this.getData(dateString);
    }

    getData = (date) => {
        // console.log("getDatadate===", date)

        let data = {
            "empCd": this.state.empCd,
            "date": date
        }
        this.clearmap()
        getTrackview(data).then(res => {
            if (res && res.status === 200) {
                // console.log("res.data.info.attendence", res.data.info.attendence)
                this.setState({
                    attendence: res.data.info.attendence
                })
            }
        })
    }

    onMapClick = (t, map, coord) => {

        const { latLng } = coord;
        const lat = latLng.lat();
        const lng = latLng.lng();

        // console.log(coord);
        // console.log(lat);
        // console.log(lng);

        let tmp = [];
        // clearmap();

        // resize image for marker
        place_red_resize = { url: place_red, scaledSize: new google.maps.Size(30, 45) };

        // add marker
        var marker = new google.maps.Marker({
            position: latLng,
            map: map,
            icon: place_red_resize,
        });
        map.panTo(latLng);

        // add new marker to state
        tmp.push(marker);
        // console.log(tmp)
        this.setState({
            markers: tmp
        })

        // add infowindow
        var infowindow = new google.maps.InfoWindow({
            content: "hello"
        });

        // declare event click to marker
        google.maps.event.addListener(marker, 'click', function () {
            infowindow.open(map, marker);
        });
    }

    clearmap = () => {
        this.setState({
            attendence: []
        })	//clear acc marker on map
    }

    dd = () => {
        console.log(this.state);
        // console.log("this.props", this.props);
    }
    renderMap = (attendence) => {
        // console.log("renderMapattendence", attendence)
        return (
            // <div id="map">
            <Map
                id="map"
                google={google}
                zoom={8}
                style={mapStyles}
                // initialCenter={{ lat: 13.7278956, lng: 100.5241235 }}
                onReady={this.onMapReady.bind(this)}
                disableDefaultUI
                zoomControl
            >
            </Map>
            // </div>
        )
    }
    onMapReady = (mapProps, map) => {
        // let attendence = this.state.attendence
        // // // console.log("attendence ==", attendence)

        // let coords = [];
        // let waypoints = [];
        // //put data from config file in an array
        // attendence.map((place) => {
        //     // console.log("place ==", place)
        //     if (place.store != null) {
        //         coords.push({ lat: parseFloat(place.store.latitude), lng: parseFloat(place.store.longitude) })
        //     }
        // });
        // // console.log("coords ==", coords)
        // if (coords.length == 0) {
        //     return
        // }
        // //instantiate directions service and directions renderer
        // const directionsService = new google.maps.DirectionsService();
        // const directionsDisplay = new google.maps.DirectionsRenderer();
        // // const directionsDisplay = new google.maps.DirectionsRenderer({suppressMarkers: true});
        // //put directions renderer to render in the map
        // directionsDisplay.setMap(map);
        // //Getting the first coordinate in the array as the start/origin
        // let start = { lat: coords[0].lat, lng: coords[0].lng };
        // //Getting the last coordinate in the array as the end/destination
        // let end = {
        //     lat: coords[coords.length - 1].lat,
        //     lng: coords[coords.length - 1].lng,
        // };

        // //putting all the coordinates between the first and last coordinate from the array as the waypoints
        // for (let i = 1; i < coords.length - 1; i++) {
        //     waypoints.push({
        //         location: { lat: coords[i].lat, lng: coords[i].lng },
        //         stopover: true,
        //     });
        // }

        // // directions requests

        // let request = {
        //     origin: start,
        //     waypoints: waypoints,
        //     destination: end,
        //     travelMode: "DRIVING",
        // };
        // //show results in the directionsrenderer
        // directionsService.route(request, function (result, status) {
        //     if (status == "OK") {
        //         directionsDisplay.setDirections(result);
        //         // var legs = result.routes[0].legs;
        //         // for (var i=0; i < legs.length;i++){
        //         //     // console.log(attendence[i]);
        //         //     console.log(legs[i].start_location);
        //         //     var contentString = '<b> '+attendence[i].store.full_address+'</b><br>';
        //         //     var marker = new google.maps.Marker({
        //         //         position: legs[i].start_location,
        //         //         map: map,
        //         //         icon: place_red_resize,
        //         //     });
        //         //     var infowindow = new google.maps.InfoWindow({
        //         //         content: contentString
        //         //     });
        //         //     google.maps.event.addListener(marker, 'click', function () {
        //         //         // infowindow.setContent(contentString);
        //         //         infowindow.open(map, marker);
        //         //     });
        //         //     // var markerletter = "A".charCodeAt(0);
        //         //     // markerletter += i;
        //         //     // markerletter = String.fromCharCode(markerletter);
        //         //     // createMarker(directionsDisplay.getMap(), legs[i].start_location, "marker" + i, "some text for marker " + i + "<br>" + legs[i].start_address, markerletter);
        //         // }
        //     }
        // });

        // //setting the autocomplete input
        // let card = document.getElementById("pac-card");
        // let input = document.getElementById("pac-input");
        // map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card);
        // let autocomplete = new google.maps.places.Autocomplete(input);

        // // console.log('aaaa', autocomplete)
        // // Bind the map's bounds (viewport) property to the autocomplete object,
        // // so that the autocomplete requests use the current map bounds for the
        // // bounds option in the request.
        // autocomplete.bindTo("bounds", map);

        // // Set the data fields to return when the user selects a place.
        // autocomplete.setFields(["address_components", "geometry", "icon", "name"]);

        // //listener for the places input
        // autocomplete.addListener("place_changed", function () {
        //     console.log(waypoints);
        //     let place = autocomplete.getPlace();
        //     if (!place.geometry) {
        //         // User entered the name of a Place that was not suggested and
        //         // pressed the Enter key, or the Place Details request failed.
        //         window.alert("No details available for input: '" + place.name + "'");
        //         return;
        //     }

        //     //Putting the previous last coordinate in the array to be part of the waypoint
        //     waypoints.push({
        //         location: {
        //             lat: coords[coords.length - 1].lat,
        //             lng: coords[coords.length - 1].lng,
        //         },
        //         stopover: true,
        //     });

        //     //putting the Place Autocomplete coordinate result in the coords array
        //     coords.push({
        //         lat: place.geometry.location.lat(),
        //         lng: place.geometry.location.lng(),
        //     });
        //     //putting the Place Autocomplete coordinate result the value of the end/destination
        //     end = place.geometry.location;

        //     //changing  request
        //     request = {
        //         origin: start,
        //         waypoints: waypoints,
        //         destination: end,
        //         travelMode: "DRIVING",
        //     };
        //     //creating new directions request
        //     directionsService.route(request, function (result, status) {
        //         if (status == "OK") {
        //             directionsDisplay.setDirections(result);
        //         }
        //     });
        // });
        var attendence = this.state.attendence
        let markers = this.state.markers

        // console.log("attendence2 ==", attendence)


        // console.log("this1", this);





        // Marker sizes are expressed as a Size of X,Y
        // where the origin of the image (0,0) is located
        // in the top left of the image.

        // Origins, anchor positions and coordinates of the marker
        // increase in the X direction to the right and in
        // the Y direction down.
        this.setState({ map: map })
        this.jQuery()

    }

    jQuery = (function () {
        var stops = [];
        // console.log("attendence ==", this.state.attendence)
        var attendence = this.state.attendence
        var map = this.state.map
        // put data from config file in an array
        attendence.map((place) => {
            // console.log("place ==", place)
            if (place.store != null) {
                stops.push({ "Geometry": { "Latitude": parseFloat(place.store.latitude), "Longitude": parseFloat(place.store.longitude) } })
            }
        });
        // console.log("stops ==", stops)
        // console.log("stops ==", stops)

        // var map = new window.google.maps.Map(document.getElementById("map"));

        // new up complex objects before passing them around
        var directionsDisplay = new window.google.maps.DirectionsRenderer({ suppressMarkers: true });
        var directionsService = new window.google.maps.DirectionsService();
        // directionsDisplay.setMap(null);
        this.Tour_startUp(stops);

        window.tour.loadMap(map, directionsDisplay);
        window.tour.fitBounds(map);
        // console.log("directionsDisplay1", directionsDisplay);

        this.setState({
            directionsDisplay: directionsDisplay
        })
        if (stops.length > 1) {
            this.calcRoute(directionsService, directionsDisplay, stops);
        }
    });
    Tour_startUp = (stops) => {
        // console.log("this11 ==", this)
        var attendence = this.state.attendence
        if (!window.tour) window.tour = {
            updateStops: function (newStops) {
                stops = newStops;
            },
            // map: google map object
            // directionsDisplay: google directionsDisplay object (comes in empty)
            loadMap: function (map, directionsDisplay) {
                var myOptions = {
                    zoom: 13,
                    center: new window.google.maps.LatLng(51.507937, -0.076188), // default to London
                    mapTypeId: window.google.maps.MapTypeId.ROADMAP
                };
                map.setOptions(myOptions);
                directionsDisplay.setMap(map);
            },
            fitBounds: function (map) {
                var bounds = new window.google.maps.LatLngBounds();
                // console.log("jQuery ==", jQuery)

                // extend bounds for each record
                jQuery.each(stops, function (key, val) {
                    var myLatlng = new window.google.maps.LatLng(val.Geometry.Latitude, val.Geometry.Longitude);
                    bounds.extend(myLatlng);
                });
                map.fitBounds(bounds);
            },

        };
    }
    calcRoute(directionsService, directionsDisplay, stops) {
        var batches = this.state.batches;
        var itemsPerBatch = 10; // google API max = 10 - 1 start, 1 stop, and 8 waypoints
        var itemsCounter = 0;
        var wayptsExist = stops.length > 0;
        // console.log("directionsDisplay", directionsDisplay);
        while (wayptsExist) {
            var subBatch = [];
            var subitemsCounter = 0;

            for (var j = itemsCounter; j < stops.length; j++) {
                subitemsCounter++;
                subBatch.push({
                    location: new window.google.maps.LatLng(stops[j].Geometry.Latitude, stops[j].Geometry.Longitude),
                    stopover: true
                });
                if (subitemsCounter == itemsPerBatch)
                    break;
            }

            itemsCounter += subitemsCounter;
            batches.push(subBatch);
            wayptsExist = itemsCounter < stops.length;
            // If it runs again there are still points. Minus 1 before continuing to
            // start up with end of previous tour leg
            itemsCounter--;
        }

        this.setState({
            batches: batches
        })

        for (var k = 0; k < batches.length; k++) {
            var lastIndex = batches[k].length - 1;
            var start = batches[k][0].location;
            var end = batches[k][lastIndex].location;

            // trim first and last entry from array
            var waypts = [];
            waypts = batches[k];
            waypts.splice(0, 1);
            waypts.splice(waypts.length - 1, 1);

            var request = {
                origin: start,
                destination: end,
                waypoints: waypts,
                travelMode: window.google.maps.TravelMode.WALKING
            };
            // console.log("this44", this)
            // (function (kk) {
            directionsService.route(request, this.mapFunction.bind(this));
            // })(k);
        }
    }
    mapFunction(result, status) {
        var batches = this.state.batches;
        var attendence = this.state.attendence
        var directionsDisplay = this.state.directionsDisplay
        // console.log("directionsDisplay3", directionsDisplay)

        // now we should have a 2 dimensional array with a list of a list of waypoints
        var combinedResults;
        var unsortedResults = [{}]; // to hold the counter and the results themselves as they come back, to later sort
        var directionsResultsReturned = 0;

        if (status == window.google.maps.DirectionsStatus.OK) {
            var kk = 0
            var unsortedResult = { order: kk, result: result };
            unsortedResults.push(unsortedResult);

            directionsResultsReturned++;

            if (directionsResultsReturned == batches.length) // we've received all the results. put to map
            {
                // sort the returned values into their correct order
                unsortedResults.sort(function (a, b) { return parseFloat(a.order) - parseFloat(b.order); });
                var count = 0;
                for (var key in unsortedResults) {
                    if (unsortedResults[key].result != null) {
                        if (unsortedResults.hasOwnProperty(key)) {
                            if (count == 0) // first results. new up the combinedResults object
                                combinedResults = unsortedResults[key].result;
                            else {
                                // only building up legs, overview_path, and bounds in my consolidated object. This is not a complete
                                // directionResults object, but enough to draw a path on the map, which is all I need
                                combinedResults.routes[0].legs = combinedResults.routes[0].legs.concat(unsortedResults[key].result.routes[0].legs);
                                combinedResults.routes[0].overview_path = combinedResults.routes[0].overview_path.concat(unsortedResults[key].result.routes[0].overview_path);

                                combinedResults.routes[0].bounds = combinedResults.routes[0].bounds.extend(unsortedResults[key].result.routes[0].bounds.getNorthEast());
                                combinedResults.routes[0].bounds = combinedResults.routes[0].bounds.extend(unsortedResults[key].result.routes[0].bounds.getSouthWest());
                            }
                            count++;
                        }
                    }
                }
                directionsDisplay.setDirections(combinedResults);
                var legs = combinedResults.routes[0].legs;
                // alert(legs.length);


                for (var i = 0; i < legs.length; i++) {
                    // console.log("attendence[i].store.full_address", attendence[i].store.full_address);
                    var markerletter = "A".charCodeAt(0);
                    markerletter += i;
                    markerletter = String.fromCharCode(markerletter);
                    this.createMarker(directionsDisplay.getMap(), legs[i].start_location, attendence[i].store.store_name + "<br>", attendence[i].store.full_address + "<br>", markerletter);
                    // this.saySomething()
                }
                var i = legs.length;
                var markerletter = "A".charCodeAt(0);
                markerletter += i;
                markerletter = String.fromCharCode(markerletter);
                this.createMarker(directionsDisplay.getMap(), legs[legs.length - 1].end_location, attendence[i].store.store_name + "<br>", attendence[i].store.full_address + "<br>", markerletter);
                // this.saySomething()
            }
        }
    }
    getMarkerImage(iconStr) {
        var icons = new Array();
        icons["red"] = new google.maps.MarkerImage("mapIcons/marker_red.png",
            // This marker is 20 pixels wide by 34 pixels tall.
            new google.maps.Size(20, 34),
            // The origin for this image is 0,0.
            new google.maps.Point(0, 0),
            // The anchor for this image is at 9,34.
            new google.maps.Point(9, 34));
        if ((typeof (iconStr) == "undefined") || (iconStr == null)) {
            iconStr = "red";
        }
        if (!icons[iconStr]) {
            icons[iconStr] = new google.maps.MarkerImage("http://www.google.com/mapfiles/marker" + iconStr + ".png",
                // This marker is 20 pixels wide by 34 pixels tall.
                new google.maps.Size(20, 34),
                // The origin for this image is 0,0.
                new google.maps.Point(0, 0),
                // The anchor for this image is at 6,20.
                new google.maps.Point(9, 34));
        }
        return icons[iconStr];

    }
    saySomething(something) {
        console.log(something);
    }
    createMarker(map, latlng, label, html, color) {
        // alert("createMarker("+latlng+","+label+","+html+","+color+")");
        var iconShadow = new google.maps.MarkerImage('http://www.google.com/mapfiles/shadow50.png',
            // The shadow image is larger in the horizontal dimension
            // while the position and offset are the same as for the main image.
            new google.maps.Size(37, 34),
            new google.maps.Point(0, 0),
            new google.maps.Point(9, 34));
        var iconShape = {
            coord: [9, 0, 6, 1, 4, 2, 2, 4, 0, 8, 0, 12, 1, 14, 2, 16, 5, 19, 7, 23, 8, 26, 9, 30, 9, 34, 11, 34, 11, 30, 12, 26, 13, 24, 14, 21, 16, 18, 18, 16, 20, 12, 20, 8, 18, 4, 16, 2, 15, 1, 13, 0],
            type: 'poly'
        };
        var infowindow = new google.maps.InfoWindow(
            {
                size: new google.maps.Size(150, 50)
            });

        var contentString = '<b>' + label + '</b><br>' + html;
        var marker = new google.maps.Marker({
            position: latlng,
            map: map,
            shadow: iconShadow,
            icon: this.getMarkerImage(color),
            shape: iconShape,
            title: label,
            zIndex: Math.round(latlng.lat() * -100000) << 5
        });

        marker.myname = label;

        google.maps.event.addListener(marker, 'click', function () {
            infowindow.setContent(contentString);
            infowindow.open(map, marker);
        });
        return marker;
    }
    onInfoWindowClose = () => {
        this.setState({
            activeMarker: null,
            activeMarkerCard: false,
            showingInfoWindow: false
        });
    }
    showMarkers = () => {
        return this.state.attendence.map((store, index) => {
            // console.log("store", store)

            return <Marker key={index} id={index} position={{
                lat: store.store.latitude,
                lng: store.store.longitude
            }}
                valuename={store.store.store_name}
                valuephone={store.store.phone1}
                valueaddress={store.store.full_address}
                valuefn={store.store.firstName_th}
                valueln={store.store.lastName_th}
                valuestore={store}
                onClick={this.onMarkerClick}
            />

        })
    }

    onMarkerClick = (props, marker) => {
        // console.log("marker", marker)
        this.setState({
            activeMarker: marker,
            activeMarkerCard: true,
            showingInfoWindow: true
        });
    };
    render() {
        const triangleCoords = [];

        const attendence = this.state.attendence
        // console.log("attendence ==", attendence)
        attendence.map((place) => {
            // console.log("place2 ==", place)
            if (place.store != null) {
                triangleCoords.push({ lat: parseFloat(place.store.latitude), lng: parseFloat(place.store.longitude) })
            }
        });
        return (
            <>
                <Space style={{ marginBottom: 16 }}>
                    <h2>Track View Sale </h2>
                    {/* <Button onClick={this.dd}>dd</Button> */}
                </Space>
                <Row>
                    <div style={{ marginBottom: 16 }}>
                        <h3 style={{ float: 'left' }}>{this.state.empCd} {this.state.firstName_th} {this.state.lastName_th}</h3>
                    </div>
                </Row>
                <div>

                </div>
                <Row gutter={[0, 0]}>
                    <Col span={18}>
                        {attendence.length > 0 &&
                            <>
                                <div style={{ height: '100%' }}>
                                    {/* <Map
                                        google={google}
                                        zoom={8}
                                        style={mapStyles}
                                        initialCenter={{ lat: 13.7278956, lng: 100.5241235 }}
                                        onReady={this.onMapReady.bind(this)}
                                        disableDefaultUI
                                        zoomControl
                                    >
                                    </Map> */}
                                    {/* {this.state.attendence ? this.renderMap(attendence) : <></>} */}
                                    {attendence.length > 1 ? this.renderMap(attendence)
                                        :
                                        <Map
                                            google={google}
                                            zoom={18}
                                            style={mapStyles}
                                            initialCenter={{ lat: attendence[0].store.latitude, lng: attendence[0].store.longitude }}
                                            disableDefaultUI
                                            zoomControl
                                        >
                                            {attendence.length > 0 && this.showMarkers()}

                                            <InfoWindow
                                                marker={this.state.activeMarker}
                                                onClose={this.onInfoWindowClose}
                                                visible={this.state.showingInfoWindow}>

                                                {this.state.activeMarker &&
                                                    <div>
                                                        <p>{attendence[0].store.store_name}</p>
                                                        <p>{attendence[0].store.full_address}</p>
                                                    </div>
                                                }

                                            </InfoWindow>
                                        </Map>
                                    }

                                    <div style={{ display: 'none' }} className="pac-card" id="pac-card">
                                        <div>
                                            <div id="title">Add new point</div>

                                            <div id="pac-container">
                                                <input
                                                    id="pac-input"
                                                    type="text"
                                                    placeholder="Enter a location"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ width: 500, height: 500 }} id={this.props.id} />
                                    {/* <div id="infowindow-content">
                                        <img src="" width="16" height="16" id="place-icon" />
                                        <span id="place-name" className="title" />
                                        <br />
                                        <span id="place-address" />
                                        <br />
                                        <span id="place-coord" />
                                    </div> */}
                                </div>
                            </>
                        }
                        {attendence.length == 0 &&
                            <div>ไม่พบข้อมูล</div>
                        }
                    </Col>
                    <Col span={6} style={{ padding: '0px 15px 0px 15px' }}>
                        <DatePicker defaultValue={moment(this.state.date)} onChange={this.onChange} size='middle' style={{ width: '100%', marginBottom: '25px' }} format={dateFormat} />
                        {attendence.length > 0 &&
                            <Timeline direction="vertical" style={{ maxHeight: '500px', overflow: 'auto', paddingTop: '20px', paddingLeft: '5px' }}>
                                {attendence.map((data, index) => {
                                    if (data.store) {
                                        // var i = attendence.length;
                                        var markerletter = "A".charCodeAt(0);
                                        markerletter += index;
                                        markerletter = String.fromCharCode(markerletter);
                                        return <Timeline.Item key={index} dot={<div className="circle">{markerletter}</div>} color="red">
                                            {/* <Timeline.Item key={index} color="red"> */}
                                            <StarTwoTone twoToneColor="#eb2f96" />
                                            {data.store.store_name}
                                            <StarTwoTone twoToneColor="#eb2f96" />
                                            {/* <p align="left"><ShopTwoTone /> {data.store.store_name}</p> */}
                                            <div align="left"><ShopTwoTone /> {moment(data.checkin_at).format("HH:mm:ss") + ' - ' + moment(data.checkout_at).format("HH:mm:ss")}</div>
                                            {/* <p align="left"><UserOutlined twoToneColor="#eb2f96" /> {data.store.salestaff.firstName_th}{' '}{data.store.salestaff.lastName_th}</p> */}
                                            <div align="left"><PhoneTwoTone /> {data.store.phone1}</div>
                                            <p align="left"><HomeTwoTone /> {data.store.full_address}</p>
                                            {/* <StarTwoTone twoToneColor="#eb2f96" /> */}
                                            {/* ผู้ติดต่อ:
                                            <StarTwoTone twoToneColor="#eb2f96" />
                                            <p align="left"><UserOutlined /> {data.store.contact_name}</p>
                                            <p align="left"><PhoneTwoTone /> {data.store.contact_phone}</p> */}
                                        </Timeline.Item>
                                    } else {
                                        return <Timeline.Item color="red">
                                            <div align="left"><ShopTwoTone /> ไม่พบข้อมูลร้านค้า </div>
                                            <div align="left"><ShopTwoTone /> {moment(data.checkin_at).format("HH:mm:ss") + ' - ' + moment(data.checkcheckout_atin_at).format("HH:mm:ss")}</div>
                                            <div align="left"><PhoneTwoTone /> {data.store.phone1}</div>
                                            <p align="left"><HomeTwoTone /> {data.store.full_address}</p>
                                        </Timeline.Item>
                                    }
                                })
                                }
                            </Timeline>
                        }
                        {attendence.length == 0 &&
                            <div>ไม่พบข้อมูล</div>
                        }
                    </Col>
                </Row>

            </>
        )
    }
}

export default View;
